var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { User } from '@/models/User';
import Roster from '@/components/roster/Roster';
import StudentDashboard from '@/views/Users/Student/Dashboard';
import TeacherDashboard from '@/views/Users/Teacher/Dashboard';
import GuardianDashboard from '@/views/Users/Guardian/Dashboard';
import RootDashboard from '@/views/Users/Root/Dashboard';
import NotificationsCard from '@/components/notifications-card/NotificationsCard';
let Dashboard = class Dashboard extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Dashboard';
    }
    mounted() { }
    get user() {
        return (this.$store.state.Auth ||
            new User({
                name: 'Undefined',
            }));
    }
};
Dashboard = __decorate([
    Component({
        components: {
            RootDashboard,
            StudentDashboard,
            TeacherDashboard,
            GuardianDashboard,
            NotificationsCard,
            Roster,
        },
    })
], Dashboard);
export default Dashboard;
